module.exports = __webpack_public_path__ + "static/media/dermatology.dd147513.webp";